import Bus from "@/lib/Bus"
import { IPrj } from "@/prj/IPrj";
import { isModuleBlock } from "typescript";
const bus: Bus = new Bus().getBus();
import { ILbl } from "./ILbl";
import {ILblSvc,lbl_api} from "./ILblSvc"
import { IPreflightResult } from "./IPreflightResult";


export class LblSvc implements ILblSvc {

    public async get_zlecenia(sql:any, conditions:any[]) : Promise<any[]>  { 
        const lbl_ret = await bus.api(lbl_api.get_zlecenia, { sql: sql, conditions:conditions});
        return lbl_ret;
    }
  
    public async get_labels(prj_id:any) : Promise<ILbl[]>  { 
        const lbl_ret = await bus.api(lbl_api.get_labels, prj_id);
        return lbl_ret;
    }

    public async get_labels_short(searcher:any) : Promise<ILbl[]>  { 
        const lbl_ret = await bus.api(lbl_api.get_labels_short,  searcher);
        return lbl_ret;
    }

    public async find_by_id(_id:any) : Promise<ILbl | undefined>  { 
        const lbl_ret = await bus.api(lbl_api.find_by_id, { _id: _id });
        return lbl_ret;
    }
    
    public async set_status(lbl:ILbl): Promise<ILbl | undefined>  {
        const lbl_ret = await bus.api(lbl_api.set_status, lbl);
        return lbl_ret;
    }

    public async update(lbl:ILbl): Promise<ILbl | undefined>  {
        const lbl_ret = await bus.api(lbl_api.update, lbl);
        return lbl_ret;
    }

    public async duplicate(_id:any): Promise<ILbl | undefined>  {
        const lbl_ret = await bus.api(lbl_api.duplicate, { _id: _id });
        return lbl_ret;
    }

    public async assign_tree(lbl_id:any, src_tree_id:string): Promise<ILbl | undefined>  {
        const lbl_ret = await bus.api(lbl_api.assign_tree, {lbl_id:lbl_id, src_tree_id: src_tree_id});
        return lbl_ret;
    }
    
    public async assign_prj(lbl:ILbl, prj: IPrj): Promise<ILbl | undefined>  {
        const lbl_ret = await bus.api(lbl_api.assign_prj, {lbl:lbl, prj: prj});
        return lbl_ret;
    }

    
    public async start_flow_sekwencja(lbl:ILbl): Promise<ILbl | undefined>  {
        const ret = await bus.api(lbl_api.start_flow_sekwencja, { lbl: lbl  });
        console.log(ret)
        return ret;
    }

    public async end_flow_sekwencja(lbl:ILbl, r:IPreflightResult, status:string):Promise<ILbl | undefined> {
        const ret = await bus.api(lbl_api.end_flow_sekwencja, { lbl: lbl  });
        console.log(ret)
        return ret;
    }


    public async start_flow_akceptacja(lbl:ILbl): Promise<ILbl | undefined>  {
        const ret = await bus.api(lbl_api.start_flow_akceptacja, { lbl: lbl  });
        console.log(ret)
        return ret;
    }

    public async end_flow_akceptacja(lbl:ILbl, r:IPreflightResult, status:string):Promise<ILbl | undefined> {
        const ret = await bus.api(lbl_api.end_flow_akceptacja, { lbl: lbl  });
        console.log(ret)
        return ret;
    }

    public async start_flow_preflight(lbl:ILbl): Promise<ILbl | undefined>  {
        const ret = await bus.api(lbl_api.start_flow_preflight, { lbl: lbl  });
        console.log(ret)
        return ret;
    }

    public async end_flow_preflight(lbl:ILbl, r:IPreflightResult, status:string):Promise<ILbl | undefined> {
        const ret = await bus.api(lbl_api.end_flow_preflight, { lbl: lbl, prefligt_result: r, status: status  });
        console.log(ret)
        return ret;
    }

    public async get_call_results(lbl:ILbl):Promise<ILbl | undefined> {
        const ret = await bus.api(lbl_api.get_call_results, { lbl: lbl});
        console.log(ret)
        return ret;
    }

    public async connect_lbls(lbls:ILbl[]):Promise<ILbl[] | undefined> {
        const ret = await bus.api(lbl_api.connect_lbls, { lbls: lbls});
        console.log(ret)
        return ret;
    }

    public async disconnect_lbls(lbl:ILbl):Promise<ILbl[] | undefined> {
        const ret = await bus.api(lbl_api.disconnect_lbls, { lbl: lbl});
        console.log(ret)
        return ret;
    }

}
